export default class HeaderSmall {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".header__small");
		this.menuClose = this.el.querySelector(".header__close");
		this.menuOpen = this.el.querySelector(".header__burger");
		this.menuOpenClass = "header--show-panel";
		this.headerSimple = document.querySelector(".header--simple");

		this.menuPanelClass = ".header__small-panel";
		this.menuPanel = this.el.querySelector(this.menuPanelClass);

		this.headerLinks = this.el.querySelector(".header__link");

		this.searchPanel = this.el.querySelector(".header__small-search-panel");
		this.searchTrigger = this.el.querySelector(".header__search");
		this.searchInput = this.el.querySelector(".header__search-input");
		this.searchShow = this.el.querySelector(
			".header__search-icon-magnifier"
		);
		this.searchClose = this.el.querySelector(".header__search-icon-close");
		this.searchOpenClass = "header--show-search";
		if (!this.headerSimple) {
			this.init();
		}
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		const self = this;
		this.menuOpen.addEventListener("click", function() {
			// hide search and show panel
			self.hideSearch();
			self.showPanel();
		});
		this.menuClose.addEventListener("click", function() {
			self.hidePanel();
		});

		this.searchShow.addEventListener("click", function(e) {
			// hidepanel and show search
			self.hidePanel();
			self.showSearch();
		});
		this.searchClose.addEventListener("click", function() {
			self.hideSearch();
		});
		this.searchInput.addEventListener("blur", function() {
			// hidepanel and show search
			self.hideSearch();
		});
		this.searchPanel.addEventListener("focusout", function(e) {
			// blur when tabbing out
			if (self.searchPanel.contains(e.relatedTarget)) {
				// don't react to this
				return;
			}
			self.hideSearch();
		});
		this.menuPanel.addEventListener("focusout", function(e) {
			// blur when tabbing out
			if (self.menuPanel.contains(e.relatedTarget)) {
				// don't react to this
				return;
			}
			self.hidePanel();
		});
	}
	showPanel() {
		const self = this;
		this.el.classList.add(this.menuOpenClass);
		// this.menuClose.focus();
		utilities.setAriaProp(this.menuPanel, "hidden", false);
		this.menuPanel.style.visibility = "visible";
	}
	hidePanel() {
		utilities.setAriaProp(this.menuPanel, "hidden", true);
		this.menuPanel.style.visibility = "hidden";
		this.el.classList.remove(this.menuOpenClass);
		// this.menuOpen.focus();
	}
	showSearch() {
		const self = this;
		this.searchInput.tabIndex = 0;
		this.el.classList.add(this.searchOpenClass);

		this.searchInput.setAttribute("aria-expanded", true);
		setTimeout(() => {
			self.searchInput.focus();
		}, 150);
	}
	hideSearch() {
		this.searchInput.tabIndex = -1;
		this.el.classList.remove(this.searchOpenClass);
		this.searchInput.setAttribute("aria-expanded", false);
	}
}
